import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete, Visibility, Download } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";

function List(props) {
  const [quotationList, setQuotationList] = useState([]);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };
  const columns = [
    {
      name: "Full Name",
      selector: (row) => row.firstName + " " + row.lastName,
    },
    {
      name: "Distributor Name",
      selector: (row) =>
        row.distributorName === ""
          ? "VURA BAU-CHEMIE LLP PRODUCTS"
          : row.distributorName,
    },
    {
      name: "No of Product",
      selector: (row) => row.products?.length,
    },
    {
      name: "Date",
      selector: (row) => moment(row.createdAt).format("DD-MM-yyyy"),
    },
    {
      name: "View",
      cell: (row) => (
        <>
          <RB.Button
            className="btn-circle"
            variant="outline-primary"
            size="sm"
            onClick={handleView(row)}
          >
            <Visibility />
          </RB.Button>
        </>
      ),
      center: true,
    },

    // {
    //   name: "Download",
    //   center: true,
    //   cell: (row) => (
    //     <>
    //       <RB.Button
    //         variant="outline-primary"
    //         size="sm"
    //         onClick={() => handleDownload(row)}
    //       >
    //         <Download />
    //       </RB.Button>
    //     </>
    //   ),
    // },

    ...(utils.hasPermission(primaryMenuRes, "Quotation", "quotation.edit") ||
    utils.hasPermission(primaryMenuRes, "Quotation", "quotation.delete")
      ? [
          {
            name: "Action",
            center: true,
            cell: (row) => (
              <>
                {utils.hasPermission(
                  primaryMenuRes,
                  "Quotation",
                  "quotation.edit"
                ) && (
                  <RB.Button
                    className="btn-circle"
                    variant="outline-primary"
                    size="sm"
                    onClick={handelEdit(row)} // Ensure to wrap this in a function call
                  >
                    <EditIcon />
                  </RB.Button>
                )}
                &nbsp;
                {utils.hasPermission(
                  primaryMenuRes,
                  "Quotation",
                  "quotation.delete"
                ) && (
                  <RB.Button
                    className="btn-circle"
                    variant="outline-danger"
                    size="sm"
                    onClick={showDelete(row)} // Wrap the function call properly
                  >
                    <Delete />
                  </RB.Button>
                )}
              </>
            ),
          },
        ]
      : []),
  ];

  useEffect(() => {
    getQuotationList();
  }, [page, userProfile?.id]);

  const getQuotationList = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("userId", userProfile?.id);
    bodyFormData.append("id", "");
    bodyFormData.append("page", page);
    bodyFormData.append("per_page", countPerPage);

    utils
      .callAPI("post", `/sales/getList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setQuotationList(res);
        } else {
          setQuotationList([]);
        }
      })
      .catch((err) => {
        setQuotationList([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/sales/getDelete?id=${row.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getQuotationList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  // const handleDownload = (row) => {
  //   window.open(row.document_link, "_blank");
  // };

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <h4></h4>
          {utils.hasPermission(
            primaryMenuRes,
            "Quotation",
            "quotation.create"
          ) && (
            <div className="card-header-action">
              {/* {utils.hasPermission(primaryMenuRes, "Quotation", "quotation.create") && ( */}
              <RB.Button
                className="btn btn-primary me-2"
                onClick={handleAddClick}
              >
                Add Quotation
              </RB.Button>
              {/* )} */}
            </div>
          )}
        </RB.Card.Header>
        <RB.Card.Body>
          {utils.hasPermission(
            primaryMenuRes,
            "Quotation",
            "quotation.view"
          ) && (
            <DataTable
              columns={columns}
              data={quotationList.result}
              highlightOnHover
              responsive
              pagination
              paginationServer
              paginationTotalRows={quotationList.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              striped
              onChangePage={(page) => setPage(page)}
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
              // subHeader
              // subHeaderComponent={subHeaderComponent}
            />
          )}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
